// extracted by mini-css-extract-plugin
module.exports = {"holder":"styles_holder__Grb0D","icon":"styles_icon__iybrr"};